module.exports = __webpack_public_path__ + "static/media/596.8ca0168c.webp";